import type { ComponentChildren } from "preact";
import { cn } from "./cn";

export type BadgeTone =
  | "neutral"
  | "success"
  | "warning"
  | "danger"
  | "info";
export type BadgeVariant = "subtle" | "solid";

const SUBTLE: Record<BadgeTone, string> = {
  neutral: "border-border bg-bg-subtle text-fg-muted",
  success: "border-success-border bg-success-bg text-success-fg",
  warning: "border-warning-border bg-warning-bg text-warning-fg",
  danger: "border-danger-border bg-danger-bg text-danger-fg",
  info: "border-info-border bg-info-bg text-info-fg",
};

const SOLID: Record<BadgeTone, string> = {
  neutral: "border-fg bg-fg text-bg",
  success: "border-success-fg bg-success-fg text-white",
  warning: "border-warning-fg bg-warning-fg text-white",
  danger: "border-danger-fg bg-danger-fg text-white",
  info: "border-info-fg bg-info-fg text-white",
};

export function Badge({
  tone = "neutral",
  variant = "subtle",
  children,
  class: extraClass,
}: {
  tone?: BadgeTone;
  variant?: BadgeVariant;
  children: ComponentChildren;
  class?: string;
}) {
  return (
    <span
      class={cn(
        "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[11px] font-medium",
        variant === "subtle" ? SUBTLE[tone] : SOLID[tone],
        extraClass,
      )}
    >
      {children}
    </span>
  );
}
